"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var server_kit_exports = {};
__export(server_kit_exports, {
  ServerKit: () => ServerKit,
  ServerKitFactory: () => ServerKitFactory
});
module.exports = __toCommonJS(server_kit_exports);
var import_noteBase = require("../marks/noteBase");
var import_qmsInlineCommentMark = require("../marks/qmsInlineCommentMark");
var import_emoji = require("../nodes/emoji");
var import_gif = require("../nodes/gif");
var import_file = require("../nodes/file");
var import_image = require("../nodes/image");
var import_reference = require("../nodes/reference");
var import_embed = require("../nodes/embed");
var import_kit = require("../kit");
var import_tiptapExtensions = require("../tiptapExtensions");
var import_common_kit = require("./common-kit");
const ServerKitFactory = /* @__PURE__ */ __name((e) => ({
  ...(0, import_common_kit.CommonKitFactory)(e),
  // ==========================================================================================
  // Extensions and kits with separate / extended implementations in the client-side editor kit
  // See file://./../../../../plugins/text-editor-resources/src/kits/editor-kit.ts
  // =============================================================================
  lists: e(import_common_kit.ListKit),
  codeSnippets: e(import_common_kit.CodeSnippetsKit),
  tables: e(import_common_kit.TableKit),
  textColorStyling: e(import_common_kit.TextColorStylingKit),
  hardBreak: e(import_tiptapExtensions.HardBreak),
  reference: e(import_reference.ReferenceNode),
  file: e(import_file.FileNode),
  image: e(import_image.ImageNode),
  embed: e(import_embed.EmbedNode),
  emoji: e(import_emoji.EmojiNode),
  gif: e(import_gif.GifNode),
  inlineNote: e(import_noteBase.NoteBaseExtension),
  // Semi-deprecated, should be removed in the future
  qmsInlineCommentMark: e(import_qmsInlineCommentMark.QMSInlineCommentMark)
  // Semi-deprecated, should be removed in the future
}), "ServerKitFactory");
const ServerKit = (0, import_kit.extensionKit)("server-kit", ServerKitFactory);
//# sourceMappingURL=server-kit.js.map
